<template>
  <div class="modal-container">
    <div class="close-btn-wrap">
      <div class="close-btn-modal" @click="$store.dispatch('closeModal')">
        <img src="../../../assets/images/icons/close.svg" />
      </div>
    </div>
    <div class="wraper-content">
      <h1 class="header">
        {{ $t('_web_signin_modal_see_more_playhera', 'See more on PlayHera') }}
      </h1>
      <h3 class="text-modal">
        {{
          $t(
            '_web_signin_modal_experience_title',
            'Log in or create account to get the full PLAYHERA experience.'
          )
        }}
      </h3>
      <router-link
        class="login-btn"
        :to="(path = `/signin?redirectTo=${$route.fullPath}`)"
      >
        <button class="login-btn" @click="$store.dispatch('closeModal')">
          {{ $t('_web_signin_modal_log_in', 'Log in') }}
        </button>
      </router-link>
      <p class="or-text">{{ $t('_web_signin_modal_or_word', 'or') }}</p>
      <router-link :to="(path = '/signup')" class="create-acc-btn">
        <button class="create-acc-btn" @click="$store.dispatch('closeModal')">
          {{ $t('_web_signin_modal_create', 'Create Account') }}
        </button>
      </router-link>
    </div>
  </div>
</template>
<script>
import { prop } from '@/utils/factories';
export default {
  name: 'SigninActionModal',
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cancel: prop(String),
  },
  watch: {
    '$route.name'() {
      this.$store.dispatch('closeModal');
    },
  },
};
</script>
<style lang="scss">
.close-btn-wrap {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.login-btn {
  width: 100%;
  height: 48px;
  background: #5a58f2;
  border: none;
  border-radius: 5px;
  color: white;
}
.text-modal {
  font-size: 16px;
  text-align: center;
  font-weight: 400;
}
.header {
  font-size: 32px;
  line-height: 40px;
}
.close-btn-modal {
  font-size: 32px;
  line-height: 20px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #30374a;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.create-acc-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 5px;
  color: #5a58f2;
  font-weight: 500;
}
.modal-container {
  background: #242938;
  border-radius: 5px;
  margin: -24px;
  padding: 20px;
  max-width: 513px;
  max-height: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wraper-content {
  max-width: 75%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 30px;
  @media (max-width: 500px) {
    max-width: 90%;
  }
  p {
    margin: auto;
  }
}
.or-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
}
</style>
